import React from 'react';
import { useSelector } from 'hooks/redux';
import { useHistory } from 'react-router-dom';

import IconBtn from '../../modules/icon-btn/icon-btn';
import currencyFormat from '../../utils/currencyFormat';
import BalanceInformer from '../balance-informer/balance-informer';
import BuyIcon from './icons/buy-icon.svg';
import SaleIcon from './icons/sale-icon.svg';
import IssueIcon from './icons/issue-icon.svg';
import { PlusIcon } from 'assets/icons';

interface BalanceHeaderProps {
  hybridValue?: number;
  cfaValue?: number;
  isHideBalanceInformer?: boolean;
}

const BalanceHeader: React.FC<BalanceHeaderProps> = ({
  cfaValue,
  isHideBalanceInformer,
}) => {
  const history = useHistory();
  const position = useSelector((state) => state.auth.profile.position);

  return (
    <>
      {!isHideBalanceInformer && (
        <div className="header__sum-informer">
          <BalanceInformer
            sm
            sum={currencyFormat(cfaValue ?? 0, false)}
            title="Денежные требования"
          />
        </div>
      )}
      <div className="header__action">
        {position === 'OPERATOR' ? (
          <>
            <IconBtn
              onClick={() => history.push('/operator/create-operation')}
              icon={<PlusIcon />}
              sm
              title="Создать операцию"
            />
          </>
        ) : position === 'SUPPLIER_BUYER' ? (
          <>
            {/* <IconBtn
              onClick={() => history.push('/assets/buying')}
              icon={BuyIcon}
              sm
              title="Купить"
            /> */}
            {/* <IconBtn
              onClick={() => history.push('/assets/selling')}
              icon={SaleIcon}
              sm
              title="Продать"
            /> */}
            {/*<IconBtn
              onClick={() => history.push('/exchange')}
              icon={<ExchangeIcon color="white" />}
              sm
              title="Обменять"
            />*/}
          </>
        ) : (
          <>
            {/* <IconBtn
              icon={IssueIcon}
              onClick={() => history.push('/assets/cfa-release')}
              sm
              title="Выпустить ЦФА"
            /> */}
          </>
        )}
        {/*<ChatBtn sm />*/}
      </div>
    </>
  );
};

export default BalanceHeader;
